// extracted by mini-css-extract-plugin
export var container = "_s2-0";
export var dotAnimation = "_s2-2";
export var dotsLoading = "_s2-1";